import React from 'react';
import { useDragLayer } from 'react-dnd';
import classNameBind from 'classnames/bind';
import styles from './CustomDragLayer.module.css';
import ListElement from '../ListElement';

const bindClasses = classNameBind.bind(styles);

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

const getItemStyles = (initialOffset, currentOffset) => {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;

  return {
    transform,
  };
};

const CustomDragLayer = () => {
  const { itemType, isDragging, item, initialOffset, currentOffset } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  const renderItem = () => {
    if (itemType) {
      if (item.multipleDragged) {
        return (
          <div className={bindClasses('item-wrapper', 'with-borders')}>
            <div className={bindClasses('list-element')}>
              <ListElement
                id={item.id}
                name={item.name}
                nameCaption={item.nameCaption}
                label={item.label}
                isSelected={item.isSelected}
              />
            </div>
            <div className={bindClasses('number')}>
              { item.count + Number(!item.isSelected) }
            </div>
          </div>
        );
      }

      return (
        <div className={bindClasses('item-wrapper')}>
          <ListElement
            id={item.id}
            name={item.name}
            nameCaption={item.nameCaption}
            label={item.label}
            isSelected={item.isSelected}
          />
        </div>
      );
    }

    return null;
  };

  if (!isDragging) {
    return null;
  }

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(initialOffset, currentOffset)}>
        {renderItem()}
      </div>
    </div>
  );
};

export default CustomDragLayer;
